import { render, staticRenderFns } from "./standardModel2.vue?vue&type=template&id=a5f90458&scoped=true"
import script from "./standardModel2.vue?vue&type=script&lang=js"
export * from "./standardModel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f90458",
  null
  
)

export default component.exports